import React, { useEffect } from "react";
import { Send, SmilePlus, X } from "lucide-react";

const ModalChat = ({
  isOpenChat,
  selectedNegotiationChat,
  currentRoleChat,
  messagesChat,
  messageChat,
  emojiList,
  setShowEmojiPickerChat,
  showEmojiPickerChat,
  handleEmojiSelect,
  loadingMessagesChat,
  sendingChat,
  errorChat,
  messagesEndRef,
  closeChatModal,
  handleMessageChange,
  handleSendMessage,
}) => {
  useEffect(() => {
    if (isOpenChat) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpenChat]);

  if (!isOpenChat) return null;

  const getSenderInfo = (role) => {
    if (role === "client") {
      return {
        name: selectedNegotiationChat?.client?.nome.split(" ")[0] || "Cliente",
        title: "cliente",
      };
    }

    if (role === "traveler") {
      return {
        name:
          selectedNegotiationChat?.traveler?.nome.split(" ")[0] || "Viajante",
        title: "viajante",
      };
    }

    if (role === "receiver") {
      return {
        name:
          selectedNegotiationChat?.receiver?.nome?.split(" ")[0] ||
          "Destinatário",
        title: "destinatário",
      };
    }

    return {
      name: "Usuário",
      title: "participante",
    };
  };

  return (
    <div className="chat-modal-overlay" onClick={closeChatModal}>
      <div className="chat-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="chat-modal-header">
          <div>
            <h2>Chat</h2>
            <p>
              {selectedNegotiationChat?.trip?.cidade_origem || "Origem"} →{" "}
              {selectedNegotiationChat?.trip?.cidade_destino || "Destino"}
            </p>
          </div>

          <button
            type="button"
            className="chat-close-btn"
            onClick={closeChatModal}
          >
            <X size={20} />
          </button>
        </div>

        <div className="chat-participants-strip">
          <div className="chat-participants-title">Participantes</div>

          <div className="chat-participants-row">
            <div className="chat-participant-chip">
              <img
                src={
                  selectedNegotiationChat?.client?.imagem ||
                  "https://i.pravatar.cc/100"
                }
                alt="Cliente"
                className="chat-participant-chip-avatar"
              />
              <div className="chat-participant-chip-info">
                <strong>
                  {selectedNegotiationChat?.client?.nome.split(" ")[0] ||
                    "Cliente"}
                </strong>
                <span>Cliente</span>
              </div>
            </div>

            <div className="chat-participant-chip">
              <img
                src={
                  selectedNegotiationChat?.traveler?.imagem ||
                  "https://i.pravatar.cc/100"
                }
                alt="Viajante"
                className="chat-participant-chip-avatar"
              />
              <div className="chat-participant-chip-info">
                <strong>
                  {selectedNegotiationChat?.traveler?.nome.split(" ")[0] ||
                    "Viajante"}
                </strong>
                <span>Viajante</span>
              </div>
            </div>

            {selectedNegotiationChat?.receiver &&
              selectedNegotiationChat?.is_receiver_data_confirmed === true && (
                <div className="chat-participant-chip">
                  <img
                    src={
                      selectedNegotiationChat?.receiver?.imagem ||
                      "https://i.pravatar.cc/100"
                    }
                    alt="Destinatário"
                    className="chat-participant-chip-avatar"
                  />
                  <div className="chat-participant-chip-info">
                    <strong>
                      {selectedNegotiationChat?.receiver?.nome?.split(" ")[0] ||
                        "Destinatário"}
                    </strong>
                    <span>Destinatário</span>
                  </div>
                </div>
              )}
          </div>
        </div>

        <div className="chat-messages">
          {loadingMessagesChat ? (
            <div className="chat-empty-state">Carregando mensagens...</div>
          ) : messagesChat.length === 0 ? (
            <div className="chat-empty-state">
              Ainda não existem mensagens nesta conversa.
            </div>
          ) : (
            messagesChat.map((msg) => {
              const role = String(msg.who_send_message || "").toLowerCase();

              const sender = getSenderInfo(role);

              const isMine = role === currentRoleChat;

              return (
                <div
                  key={msg.id}
                  className={`chat-message ${
                    isMine ? "chat-message-mine" : "chat-message-other"
                  }`}
                >
                  <div className="chat-message-bubble">
                    <div
                      className={`chat-message-author ${
                        role === "client"
                          ? "role-client"
                          : role === "traveler"
                            ? "role-traveler"
                            : role === "receiver"
                              ? "role-receiver"
                              : ""
                      }`}
                    >
                      {sender.name} ⦿ {sender.title}
                    </div>

                    <p>{msg.message}</p>

                    <small>
                      {new Date(msg.created_at).toLocaleString("pt-BR")}
                    </small>
                  </div>
                </div>
              );
            })
          )}
          <div ref={messagesEndRef} />
        </div>

        {errorChat && <div className="chat-error">{errorChat}</div>}

        <form className="chat-input-area" onSubmit={handleSendMessage}>
          <button
            type="button"
            className="chat-emoji-btn"
            onClick={() => setShowEmojiPickerChat((prev) => !prev)}
          >
            <SmilePlus size={20} />
          </button>

          {showEmojiPickerChat && (
            <div className="chat-emoji-picker">
              {emojiList.map((emoji) => (
                <button
                  key={emoji}
                  type="button"
                  className="chat-emoji-item"
                  onClick={() => handleEmojiSelect(emoji)}
                >
                  {emoji}
                </button>
              ))}
            </div>
          )}

          <input
            type="text"
            className="chat-input"
            placeholder="Escreva a sua mensagem..."
            value={messageChat}
            onChange={(e) => handleMessageChange(e.target.value)}
          />

          <button
            type="submit"
            className="chat-send-btn"
            disabled={sendingChat}
          >
            <Send size={18} />
          </button>
        </form>
      </div>
    </div>
  );
};

export default ModalChat;
